module.exports = __webpack_public_path__ + "static/media/lu.e448adf8.svg";